<form [formGroup]="form" (ngSubmit)="onSubmit()" class="card localization-settings">
  <div class="card-body">
    <p class="localization-settings__description small mb-4">
      {{ 'Settings::Localization:PageDescription' | abpLocalization }}
    </p>

    <div class="row g-3 g-lg-4">
      @if (showsFormats) {
      <div class="col-12 col-lg-6">
        <label class="form-label" [attr.for]="null">
          {{ 'Settings::Localization:SystemTimeZone' | abpLocalization }}
        </label>
        <cx-select
          class="w-100"
          formControlName="timeZone"
          [options]="timeZoneOptions"
          optionLabel="displayName"
          optionValue="name"
          [placeholder]="'Settings::TimeZone:Placeholder' | abpLocalization"
          [loading]="isBusy"
          [filter]="true"
          [showClear]="true"
          appendTo="body" />
      </div>

      <div class="col-12 col-lg-6">
        <label class="form-label" [attr.for]="null">
          {{ 'Settings::Localization:DateFormat' | abpLocalization }}
        </label>
        <cx-select
          class="w-100"
          formControlName="dateFormat"
          [options]="dateFormatOptions"
          optionLabel="label"
          optionValue="value"
          [loading]="isLoading"
          appendTo="body" />
        @if (isControlInvalid('dateFormat')) {
          <div class="localization-settings__error small">
            {{ 'Settings::Localization:DateFormat' | abpLocalization }}
            {{ '::Required' | abpLocalization }}
          </div>
        }
      </div>

      <div class="col-12 col-lg-6">
        <label class="form-label" [attr.for]="null">
          {{ 'Settings::Localization:TimeFormat' | abpLocalization }}
        </label>
        <cx-select
          class="w-100"
          formControlName="timeFormat"
          [options]="timeFormatOptions"
          optionLabel="label"
          optionValue="value"
          [loading]="isLoading"
          appendTo="body" />
        @if (isControlInvalid('timeFormat')) {
          <div class="localization-settings__error small">
            {{ 'Settings::Localization:TimeFormat' | abpLocalization }}
            {{ '::Required' | abpLocalization }}
          </div>
        }
      </div>

      <div class="col-12 col-lg-6">
        <label class="form-label" [attr.for]="null">
          {{ 'Settings::Localization:PhoneNumberFormat' | abpLocalization }}
        </label>
        <cx-select
          class="w-100"
          formControlName="phoneNumberFormat"
          [options]="phoneNumberFormatOptions"
          optionLabel="label"
          optionValue="value"
          [loading]="isLoading"
          appendTo="body" />
        @if (isControlInvalid('phoneNumberFormat')) {
          <div class="localization-settings__error small">
            {{ 'Settings::Localization:PhoneNumberFormat' | abpLocalization }}
            {{ '::Required' | abpLocalization }}
          </div>
        }
      </div>

      <div class="col-12 col-lg-6">
        <label class="form-label" [attr.for]="null">
          {{ 'Settings::Localization:NumberFormat' | abpLocalization }}
        </label>
        <cx-select
          class="w-100"
          formControlName="numberFormat"
          [options]="numberFormatOptions"
          optionLabel="label"
          optionValue="value"
          [loading]="isLoading"
          appendTo="body" />
        @if (isControlInvalid('numberFormat')) {
          <div class="localization-settings__error small">
            {{ 'Settings::Localization:NumberFormat' | abpLocalization }}
            {{ '::Required' | abpLocalization }}
          </div>
        }
      </div>
      }

      @if (showsLanguage) {
      <div class="col-12 col-lg-6">
        <label class="form-label" [attr.for]="null">
          {{ 'Settings::Localization:Language' | abpLocalization }}
        </label>
        <cx-select
          class="w-100"
          formControlName="language"
          [options]="languageOptions"
          optionLabel="displayName"
          optionValue="cultureName"
          [placeholder]="'Settings::Localization:LanguagePlaceholder' | abpLocalization"
          [loading]="isBusy"
          appendTo="body" />
        @if (isControlInvalid('language')) {
          <div class="localization-settings__error small">
            {{ 'Settings::Localization:Language' | abpLocalization }}
            {{ '::Required' | abpLocalization }}
          </div>
        }
      </div>
      }
    </div>
  </div>

  <div class="localization-settings__footer">
    <cx-form-actions
      layout="inline"
      cancelVariant="outline-acx"
      [cancelLabel]="'::Cancel' | abpLocalization"
      [saveLabel]="isSubmitting ? ('::Saving' | abpLocalization) : ('::Save' | abpLocalization)"
      [disabled]="isBusy"
      [isSubmitting]="isSubmitting"
      (cancel)="onCancel()" />
  </div>
</form>
